import React from "react"
import PageBanner from "../Components/PageBanner";

const Allcoursesp = () => {
    return (
        <div className="pt-20 bg-[#F6F5F1]">
            <PageBanner eyebrow="Programs" title="Our courses" />
        </div>
    )
}

export default Allcoursesp;